import React, {useState} from "react";
import {usePage, router, Link, useForm} from "@inertiajs/react";
import {Container, Table, Button, Form, Row, Col, Card} from "react-bootstrap";
import NoNewsletterBanner from "../../../Components/Campaigns/NoNewsletterBanner.jsx";

/**
 * Pflege der Absender-Postfach-Whitelist für E-Mail-Kampagnen. Die
 * automatische Erkennung über Microsoft Graph ("Postfächer neu laden")
 * ist in Slice 2 bewusst nur ein Platzhalter (siehe
 * CampaignSenderMailboxController::discover) - bis dahin lassen sich
 * Postfächer hier manuell hinzufügen.
 */
export default function Index() {
    const {mailboxes} = usePage().props;
    const [discovering, setDiscovering] = useState(false);

    const {data, setData, post, processing, errors, reset} = useForm({
        email: "",
        display_name: "",
    });

    const handleToggle = (mailbox) => {
        router.post(`/campaigns/mailboxes/${mailbox.id}/toggle`);
    };

    const handleDiscover = () => {
        setDiscovering(true);
        router.post("/campaigns/mailboxes/discover", {}, {
            onFinish: () => setDiscovering(false),
        });
    };

    const handleAdd = (e) => {
        e.preventDefault();
        post("/campaigns/mailboxes/add", {
            onSuccess: () => reset(),
        });
    };

    return (
        <Container fluid className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h1>Absender-Postfächer</h1>
                <div className="d-flex gap-2">
                    <Link href="/campaigns" className="btn btn-outline-secondary">Zurück zu Kampagnen</Link>
                    <Button variant="secondary" disabled={discovering} onClick={handleDiscover}>
                        Postfächer aus Graph neu laden
                    </Button>
                </div>
            </div>
            <NoNewsletterBanner/>

            <Table striped bordered hover className="mt-3">
                <thead>
                <tr>
                    <th>E-Mail</th>
                    <th>Anzeigename</th>
                    <th>Freigegeben</th>
                    <th>Entdeckt am</th>
                </tr>
                </thead>
                <tbody>
                {(mailboxes ?? []).length === 0 && (
                    <tr>
                        <td colSpan={4} className="text-center text-muted">Noch keine Postfächer erfasst.</td>
                    </tr>
                )}
                {(mailboxes ?? []).map((mailbox) => (
                    <tr key={mailbox.id}>
                        <td>{mailbox.email}</td>
                        <td>{mailbox.display_name ?? "-"}</td>
                        <td>
                            <Form.Check
                                type="switch"
                                id={`mailbox-allowed-${mailbox.id}`}
                                checked={mailbox.is_allowed}
                                onChange={() => handleToggle(mailbox)}
                            />
                        </td>
                        <td>{mailbox.discovered_at ?? "-"}</td>
                    </tr>
                ))}
                </tbody>
            </Table>

            <Card className="mt-4">
                <Card.Header>Postfach manuell hinzufügen</Card.Header>
                <Card.Body>
                    <Form onSubmit={handleAdd} noValidate>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>E-Mail</Form.Label>
                            <Col sm={4}>
                                <Form.Control value={data.email} onChange={(e) => setData("email", e.target.value)}
                                              className={errors.email ? "is-invalid" : ""}/>
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </Col>
                            <Form.Label column sm={2}>Anzeigename</Form.Label>
                            <Col sm={4}>
                                <Form.Control value={data.display_name}
                                              onChange={(e) => setData("display_name", e.target.value)}/>
                            </Col>
                        </Form.Group>
                        <Button type="submit" disabled={processing}>Hinzufügen</Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
}
